import Logo from '../../Logo';
import RecursiveMenu from './components/RecursiveMenu';
import VersionNumber from './components/VersionNumber';

interface IMenuProps {
  closeMobileSideMenu: () => void;
}

const Menu = (props: IMenuProps) => {
  const { closeMobileSideMenu } = props;

  return (
    <>
      <VersionNumber />
      {/* <Logo closeMobileSideMenu={closeMobileSideMenu} /> */}
      <RecursiveMenu closeMobileSideMenu={closeMobileSideMenu} />
    </>
  );
};

export default Menu;
